import { ENV, IS_NCM } from "@/env";

function getClientId(): string {
  // Runtime detection: use Dev client ID for NCM staging environment
  if (IS_NCM && typeof window !== "undefined" && window?.location?.host.includes("metx-staging.ncm")) {
    return "MetX Workbench Dev";
  }
  return ENV.oauthClientId;
}

export const oAuthConfiguration = {
  clientId: getClientId(),
  oauthAuthorizationUrl: `${ENV.baseUrlLogin}/api/v2/oauth/authorize`,
  oauthLogoutUrl: `${ENV.baseUrlLogin}/api/v2/oauth/logout`,
  codeChallengeMethod: "S256",
  oauthRedirectUrl: `${window.location.protocol}//${window.location.host}/oauth`,
};
